<template>
  <div class="notfound">
    <CircleMessage>
      <b>{{ translate('OOPS') }}...</b><br>
      <span>{{ translate('ERROR.NOT_FOUND') }}</span>
    </CircleMessage>
  </div>
</template>

<script setup lang="ts">
import CircleMessage from "@/components/circleMessage/CircleMessage.vue";
import {translate} from "../i18n";
</script>

<style scoped lang="less">
notfound {
  height: 100%;
  width: 100%;
}
</style>